// extracted by mini-css-extract-plugin
export default {"doughnutChart":"DoughnutChart_doughnutChart__h4jWO"};